<template>
  <el-row
    class="fullpage"
    type="flex"
    justify="center"
    align="middle"
  >
    <el-col
      :xs="22"
      :sm="18"
      :md="12"
      :lg="6"
      class="fullpage__container"
    >
      <slot />
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'FullPage',
  };
</script>

<style lang="scss">
  .fullpage {
    width: 100%;
    height: 100%;

    &__container {
      background: $--color-black-lighter;
      box-shadow: $--box-shadow-base;
      padding: 50px;
    }
  }
</style>
